import { useState, useEffect } from 'react';
import { EVENTS } from '@trip-ux/constants';
import { SCROLL_DIRECTION } from '../constants';

export const useScrollDirection = (
  initialDirection: SCROLL_DIRECTION = SCROLL_DIRECTION.DOWN,
  thresholdPixels = 0,
  off = false
): SCROLL_DIRECTION => {
  const [scrollDir, setScrollDir] = useState(initialDirection);
  useEffect(() => {
    let lastScrollY = window.pageYOffset;
    let ticking = false;
    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;
      if (Math.abs(scrollY - lastScrollY) < thresholdPixels) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? SCROLL_DIRECTION.DOWN : SCROLL_DIRECTION.UP);
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };
    if (!off) {
      window.addEventListener(EVENTS.SCROLL, onScroll);
    } else {
      setScrollDir(initialDirection);
    }

    return () => window.removeEventListener(EVENTS.SCROLL, onScroll);
  }, [initialDirection, thresholdPixels, off]);
  return scrollDir;
};

export default useScrollDirection;
